import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setUser
} from 'store/redux/users'

export default function * requestActivateUser (action) {
  const { id } = action.payload

  const state = yield select()

  const user = state.kanbo.users[id]

  let optimisticAction
  if (user) {
    optimisticAction = yield optimisticPut(setUser({
      id,
      isActive: true
    }))
  }

  try {
    yield call(apiAction, 'ActivateProfile', {
      profileKey: user.profileKey
    })

    if (optimisticAction) {
      yield optimisticAction.commit()
    }
  } catch (error) {
    if (optimisticAction) {
      yield optimisticAction.revert()
    }

    if (error.code !== 2001) { // Profile is active
      throw error
    }
  }
}
